import {
    Grid,
    TableCell,
    TableRow,
    Typography
} from '@mui/material';
import React from 'react';

import { AdditionalInfoDetailsProps } from './types';
import { renderFields } from '../helper';
import { muiStyles } from '../styles';
import { WithdrawalInstructionFields } from '../types';

const additionalInfoFields: WithdrawalInstructionFields = [
    {
        label: 'Beneficiary Information 1',
        valueProp: 'BeneInfo1',
        optional: true
    },
    {
        label: 'Beneficiary Information 2',
        valueProp: 'BeneInfo2',
        optional: true
    },
    {
        label: 'Beneficiary Information 3',
        valueProp: 'BeneInfo3',
        optional: true
    },
    {
        label: 'Beneficiary Information 4',
        valueProp: 'BeneInfo4',
        optional: true
    },
    {
        label: 'Bank to Bank Information 1',
        valueProp: 'BankToBankInfo1',
        optional: true
    },
    {
        label: 'Bank to Bank Information 2',
        valueProp: 'BankToBankInfo2',
        optional: true
    },
    {
        label: 'Bank to Bank Information 3',
        valueProp: 'BankToBankInfo3',
        optional: true
    },
    {
        label: 'Bank to Bank Information 4',
        valueProp: 'BankToBankInfo4',
        optional: true
    }
];

export const BeneficiaryAdditionalInfoDetails: React.FC<AdditionalInfoDetailsProps> = (props) => {
    const {
        displayComponent,
        withdrawalInstruction
    } = props;

    const classes = muiStyles(props);

    if (
        !withdrawalInstruction.BeneInfo1 && !withdrawalInstruction.BeneInfo2 &&
        !withdrawalInstruction.BeneInfo3 && !withdrawalInstruction.BeneInfo4 &&
        !withdrawalInstruction.BankToBankInfo1 && !withdrawalInstruction.BankToBankInfo2 &&
        !withdrawalInstruction.BankToBankInfo3 && !withdrawalInstruction.BankToBankInfo4
    ) {
        if (displayComponent === 'Table') {
            return (
                <TableRow className={classes.tableRow}>
                    <TableCell
                        className={classes.tableCell}
                        colSpan={2}
                    >
                        No Additional Information
                    </TableCell>
                </TableRow>
            );
        }

        return (
            <Grid
                className={classes.detailRow}
                container
                direction='row'
                justifyContent='space-between'
                spacing={0}
                wrap='nowrap'
            >
                <Typography
                    className={classes.labelFont}
                    variant='body2'
                >
                    No Additional Information
                </Typography>
            </Grid>
        );
    }

    return (
        <>
            {renderFields(withdrawalInstruction, additionalInfoFields, classes, displayComponent)}
        </>
    );
};